<div class="inner-page-bg-right">
  <header>
    <div class="container">
      <div class="row">
        <div class="col-sm-12">
          <div class="inner-header">
            <div class="logo">
              <a href="javascript:void();" [routerLink]="'/login'"> <img [src]="businesslogo"
                  alt=""></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
  <section class="banner-inner-pages">
    <div class="container">
      <div class="row">
        <div class="col-sm-12 col-md-7 col-lg-6 left-panel">
          <div class="banner-left-text">
            <h1 data-aos="fade-up">Thank You for Registering! 🎉</h1>
          </div>
          <h3 class="mt-3">You're almost there!</h3>
          <h4 class="mt-3">Final Step: Enter the confirmation code sent to your registered email from <br><a
            href="mailto:consult@scanfluence.com"><strong>no-reply@scanfluence.ca</strong></a> to complete your registration.</h4>
          <h4>
            Once verified, you'll be redirected to the Scanfluence Sign-In page, where you can start using the system right away! 🚀<br>
          </h4>
          <!-- <h4 class="mt-3">We have sent the verification code to {{email}}</h4> -->
          <form [formGroup]="loginForm" class="otp-form" (ngSubmit)="onSubmit()" autocomplete="off">
            <div class="row">
              <mat-form-field appearance="outline" class="otp-field">
                <input matInput type="text" OnlyNumber maxlength="1" formControlName="digit1" #digit1
                  (keydown)="onKeyDown($event, digit1, null)" (input)="onInput(digit1, digit2)" autofocus />
              </mat-form-field>
              <mat-form-field appearance="outline" class="otp-field">
                <input matInput type="text" OnlyNumber maxlength="1" formControlName="digit2" #digit2
                  (keydown)="onKeyDown($event, digit2, digit1)" (input)="onInput(digit2, digit3)" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="otp-field">
                <input matInput type="text" OnlyNumber maxlength="1" formControlName="digit3" #digit3
                  (keydown)="onKeyDown($event, digit3, digit2)" (input)="onInput(digit3, digit4)" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="otp-field">
                <input matInput type="text" OnlyNumber maxlength="1" formControlName="digit4" #digit4
                  (keydown)="onKeyDown($event, digit4, digit3)" (input)="onInput(digit4, digit5)" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="otp-field">
                <input matInput type="text" OnlyNumber maxlength="1" formControlName="digit5" #digit5
                  (keydown)="onKeyDown($event, digit5, digit4)" (input)="onInput(digit5, digit6)" />
              </mat-form-field>
              <mat-form-field appearance="outline" class="otp-field">
                <input matInput type="text" OnlyNumber maxlength="1" formControlName="digit6" #digit6
                  (keydown)="onKeyDown($event, digit6, digit5)" (input)="onInput(digit6, null)" />
              </mat-form-field>
            </div>

            <div class="row">
              <div class="col-sm-12">
                <button class="mb-3" type="submit" [disabled]="isButtonDisabled" mat-raised-button color="primary">Submit
                  CODE</button>
                  <h4>            
                    ✅ Validating and redeeming coupons is quick and simple. <br>
                    ✅ Get your own store QR code with curated offers and attract more customers! <br>
                    ✅ Seamlessly post on Facebook and share offers with your followers. <br>
                    ✅ Explore other powerful features designed to enhance your experience. <br>
                    ✅ Check out our training videos to get the most out of Scanfluence. <br>
                  </h4>
                <h4>
                  🔹 Didn’t receive the code? <br><br>
                  ✔ Check your junk or spam folder. <br>
                  ✔ Click <a href="javascript:void();" (click)="onSendAgainOTP()"
                  style="text-decoration: none;">Resend</a> to generate a new code.
                </h4>
                <h4>📩 Need assistance? Please contact us at <a
                    href="mailto:consult@scanfluence.com"><strong>consult&#64;scanfluence.com</strong></a></h4><br><br><br>
              </div>
            </div>
            <!--
            <div class="row">
              <div class="col-sm-8 col-lg-6">
                <span *ngIf="showTimer">Time Remaining: </span> <span *ngIf="showTimer"> {{ timer }}</span>
                <a *ngIf="!showTimer" href="javascript:void();" (click)="onSendAgainOTP()"
                  style="text-decoration: none;">Resend OTP?</a>
              </div>
              <div class="col-sm-4 col-lg-4 text-right">
                <button type="submit" [disabled]="isButtonDisabled" mat-raised-button color="primary">Verify</button>
              </div>
            </div> -->
          </form>
        </div>
        <div class="col-sm-12 col-md-5 col-lg-6 signup-img"> <img src="./assets/images/signup-1.png" alt="">
        </div>
      </div>
    </div>
  </section>
</div>
<app-admin-footer></app-admin-footer>